var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUseIcon2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 65,
    height: 65,
    viewBox: "0 0 65 65",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_633_15618)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 32.6065,
    cy: 32.7005,
    r: 22.7222,
    fill: "#262B23"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.6503 35.3658C37.3014 35.3658 41.0686 31.6644 41.0686 27.0945C41.0686 22.5247 37.3014 18.8233 32.6503 18.8233C27.9992 18.8233 24.232 22.5247 24.232 27.0945C24.232 31.6644 27.9992 35.3658 32.6503 35.3658ZM32.6503 39.5015C27.0311 39.5015 18.6236 41.9393 17.6636 46.7925C17.6636 46.7925 23.3678 53.4252 32.8562 53.1772C42.3446 52.9292 47.5882 46.6835 47.5882 46.6835C45.0913 40.9405 38.2695 39.5015 32.6503 39.5015Z",
    fill: "#86FFC6"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_633_15618",
    x: 0.41669,
    y: 0.510715,
    width: 64.3795,
    height: 64.3796,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4.73379
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.12 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_633_15618"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_633_15618",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUseIcon2);
export default __webpack_public_path__ + "static/media/useIcon2.e9d7a221129ed7d26e80a94386b429fb.svg";
export { ForwardRef as ReactComponent };